// Auto-generated from menu.json
export default {
  "tagName": "ui-menu",
  "content": [
    "item"
  ],
  "types": [
    "selection"
  ],
  "variations": [
    "evenly-spaced",
    "fitted",
    "vertical",
    "inset"
  ],
  "settings": [
    "items",
    "value"
  ],
  "attributes": [
    "item",
    "selection",
    "evenly-spaced",
    "fitted",
    "vertical",
    "inset",
    "items",
    "value"
  ],
  "propertyTypes": {
    "item": "string",
    "selection": "boolean",
    "evenly-spaced": "boolean",
    "fitted": "boolean",
    "vertical": "boolean",
    "inset": "boolean",
    "items": "array",
    "value": "string"
  },
  "defaultValues": {
    "items": [],
    "value": ""
  }
};
